import { configureStore } from '@reduxjs/toolkit';
import authReducer from './authSlice';
import menuReducer from './menuSlice';
import planReducer from './planSlice';
import kdsReducer from './kdsSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    menus: menuReducer,
    plans: planReducer,
    kds: kdsReducer,
  },
});
